import { Box, Button, DialogTitle, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: '24px 24px 16px',
  backgroundColor: theme.palette.primary.main,
  color: 'white',
}));

export const IconContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '16px',
});

export const LoginIcon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  borderRadius: '50%',
  padding: '12px',
  marginTop: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
}));

export const SignupIcon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  borderRadius: '50%',
  padding: '12px',
  marginTop: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
}));

export const ResetIcon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  borderRadius: '50%',
  padding: '12px',
  marginTop: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    transition: 'all 0.3s ease',
  },
  '& .MuiInputAdornment-root': {
    color: theme.palette.text.secondary,
  }
}));

export const StyledButton = styled(Button)(() => ({
  padding: '12px',
  borderRadius: '8px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
  },
}));